import React from "react";
import {Mutation, Query} from "react-apollo";
import queries from "../../../queries";
import _ from "lodash";
import {FormattedMessage} from "react-intl";
import {stateOrValue} from "../../../utils";
import HtmlPicker from "./pickers/HtmlPicker";
import AIPicker from "./pickers/AIPicker";

class HtmlCellEditor extends React.Component  {

  state = {
    i18n: {}
  };

  setI18nState(language, oldState, newState) {
    this.setState({i18n: {...this.state.i18n, [language.code]: {...oldState, ...newState}}});
  }

  render() {
    const { cell } = this.props;

    return (
      <Query query={queries.cells.html.get} variables={{ id: cell.id }}>
        {({ loading, error, data }) => {
          if (loading) return null;
          if (error) return `Error!: ${error}`;

          const { htmlCell } = data;
          if (!htmlCell) return null;

          return (
            <Mutation
              mutation={queries.cells.html.update}
              refetchQueries={() => [{ query: queries.cells.html.get, variables: {id: cell.id} }]}
            >
              {(updateHtmlCell) => (
                <div>
                  <div className={'tsk-input-line'}>
                    <HtmlPicker value= {stateOrValue(this.state.html, htmlCell.html)} onChange={(e) => {
                      this.setState({html: e})}}></HtmlPicker>
                  </div>
                  <div className={'tsk-input-line'}>
                    <AIPicker type={'component'} onResult={(e) => {
                        console.log(e)
                        this.setState({html: e.data})}}></AIPicker>
                
                  </div>
                  <div className={'tsk-bottom-buttons'}>
                    <button
                      className={'tsk-button'}
                      onClick={() => {

                        const data = {
                          id: cell.id,
                          html: this.state.html,
                        };
                        updateHtmlCell({ variables: { input: data }})
                      }}>
                      <FormattedMessage id={'common.button.submit'} />
                    </button>
                  </div>
                </div>
              )}
            </Mutation>
          )
        }}
      </Query>
    );
  }
}

export default HtmlCellEditor;
